<template>
  <div class="ballot-question">
    <h5 class="title is-5">{{ component.props?.title }}</h5>
    <div v-if="component.props?.description" v-html="safeDescription" />
  </div>
</template>

<script setup>
import { computed } from 'vue'
import DOMPurify from 'dompurify'

const props = defineProps({
  component: { type: Object, required: true },
  shareholder: { type: Object, default: () => ({}) },
  mode: { type: String, default: 'vote' },
  form: { type: Object, default: null },
})

const safeDescription = computed(() =>
  DOMPurify.sanitize(props.component.props?.description || ''),
)
</script>

<style scoped>
.ballot-question {
  margin-top: 12px;
}
</style>
